import { render } from "./QuickSwitcher.vue?vue&type=template&id=e0d823e8&scoped=true"
import script from "./QuickSwitcher.vue?vue&type=script&lang=js"
export * from "./QuickSwitcher.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-e0d823e8"

export default script